import React, { useEffect, useState } from "react";
import "./AdminNotifications.css";
import Container from "react-bootstrap/Container";
import { Row, Card, Col } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Link } from "react-router-dom";
import {
  GetNotifications,
  GetNotificationUnreadCount,
  MarkNotificationRead,
} from "../../apis/NotificationAPI";
import dateFormat from "dateformat";

export default function AdminNotifications() {
  const [notificationList, setNotificationList] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  async function GetUserNotifications() {
    var result = await GetNotifications();
    var data = result.data;
    setNotificationList(data);
  }

  async function GetNotificationCount() {
    var result = await GetNotificationUnreadCount();
    setUnreadCount(result.data);
  }

  async function MarkNotification() {
    var result = await MarkNotificationRead();
    console.log(result);
  }

  useEffect(() => {
    GetUserNotifications();
    GetNotificationCount();
    MarkNotification();
  }, []);

  window.addEventListener("notification", () => {
    GetUserNotifications();
    GetNotificationCount();
    MarkNotification();
  });

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <h1>
                  Notifications {unreadCount > 0 ? `(${unreadCount})` : ""}
                </h1>
                <Row className="mt-5">
                  <Col lg={12}>
                    <Card className="notifications-card">
                      <div className="card-head">
                        <div className="card-title h5">Notifications</div>
                      </div>
                      <ul className="notifications-list">
                        {notificationList.map((item) =>
                          item.order_status_name === "New" ? (
                            <li className={item.view_id === 0 ? "unread" : ""}>
                              <p>
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                was submitted by{" "}
                                {item.requestor_name === ""
                                  ? "System"
                                  : item.requestor_name}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Completed" ? (
                            <li className={item.view_id === 0 ? "unread" : ""}>
                              <p>
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                was marked completed by{" "}
                                {item.investigator_name === "" || item.reopened != 0
                                  ? item.order_user
                                  : item.investigator_name}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Invoiced" ? (
                            <li className={item.view_id === 0 ? "unread" : ""}>
                              <p>
                                Invoice generated for Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name ===
                            "Statements Generated" ? (
                            <li className={item.view_id === 0 ? "unread" : ""}>
                              <p>
                                Statement generated for Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "In Progress" ? (
                            <li className={item.view_id === 0 ? "unread" : ""}>
                              <p>
                                {item.investigator_name} started working on
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Preliminary" ? (
                            <li className={item.view_id === 0 ? "unread" : ""}>
                              <p>
                                {item.investigator_name} submitted preliminary
                                report for Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                .
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Assigned" ? (
                            <li className={item.view_id === 0 ? "unread" : ""}>
                              <p>
                                {item.order_user} assigned Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                to {item.investigator_name}.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Initial Review" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.investigator_name} has sent Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}'s
                                </Link>{" "}
                                initial report for review.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Initial Reviewed" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has reviewed initial report of
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}.
                                </Link>{" "}
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Prelim In Review" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.investigator_name} has sent Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}'s
                                </Link>{" "}
                                prelim report for review.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Prelim Reviewed" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has reviewed prelim report of
                                Order number{" "}
                                <Link
                                  to={`/Admin/OrderDetail?id=${item.order_id}`}
                                >
                                  {item.order_id}.
                                </Link>{" "}
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : (
                            ""
                          )
                        )}
                      </ul>
                      {/* <Card.Link href="#">View All</Card.Link> */}
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
